<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>医生群记录详情</span>
      <el-button type="primary" size="medium" style="width: 80px" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="flex_between" style="align-items: flex-end">
          <div class="flex">
            <img
              :src="doctor_info.head_img"
              alt=""
              style="width: 120px; margin-right: 12px"
            />
            <div class="column-between">
              <div>
                <span>{{ doctor_info.doctor_name }}</span>
                <span style="margin: 0 30px">{{
                  doctor_info.department_name
                }}</span>
                <span>{{ doctor_info.title }}</span>
              </div>
              <div>{{ doctor_info.hospital }}</div>
              <div>
                {{ doctor_info.province_name }}{{ doctor_info.city_name
                }}{{ doctor_info.district_name }}
              </div>
            </div>
          </div>
          <el-button
            type="primary"
            size="medium"
            @click="delAllGroup"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('687') : false
            "
            >批量解散群</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6; margin-top: 12px">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="changeOrder"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection"> </el-table-column>
            <el-table-column
              prop="create_time"
              label="群创建时间"
            ></el-table-column>
            <el-table-column
              prop="people_num"
              label="群人数"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="msg_time"
              label="最新消息时间"
              sortable="custom"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('687')
                      : false
                  "
                  @click="delGroup(scope.row.group_id)"
                  >解散群</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 30px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      is_test: 1,
      doctor_name: '',
      phone: '',
      hospital: '',
      order: 1,
      selection_id: '',
      doctor_info: {}
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取医生信息
    getDoctor() {
      let doctor_id = this.$route.query.doctor_id;
      this.axios
        .post('platform/doctor/doctorItem', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.doctor_info = res.data.info;
          }
        });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_id: this.$route.query.doctor_id,
        order: this.order
      };
      this.axios
        .post('platform/doctor/getDoctorConsoleGroupList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              item.msg_time = item.msg_time
                ? dayjs.unix(item.msg_time).format('YYYY-MM-DD HH:mm')
                : '';
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChange(val) {
      let selection = val.map((item) => {
        return item.group_id;
      });
      this.selection_id = selection.toString();
    },
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == 'ascending') {
        if (prop == 'people_num') {
          this.order = 2;
        } else if (prop == 'msg_time') {
          this.order = 4;
        }
      }
      //降序
      if (order == 'descending') {
        if (prop == 'people_num') {
          this.order = 3;
        } else if (prop == 'msg_time') {
          this.order = 5;
        }
      }
      if (!order) {
        this.order = 1;
      }
      this.getList();
    },
    //解散群组
    delGroup(group_id) {
      this.$confirm('确定要解散群吗？', '提示', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/doctor/delDoctorConsoleGroup', { group_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('群组已解散');
                this.getList();
              }
            });
        })
        .catch();
    },
    //批量解散群组
    delAllGroup() {
      if (!this.selection_id) {
        this.$message.error('请勾选需要操作的群组');
        return false;
      }
      this.delGroup(this.selection_id);
    },
    back() {
      history.back();
    }
  },

  created() {
    this.getList();
    this.getDoctor();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>